import React from 'react';
import { Route, Routes, Navigate, Outlet } from 'react-router-dom';
import { useTheme } from '@mui/material';
import { AdminDrawer, DRAWER_WIDTH } from './drawer';
import { RoleListPage } from './role-list-page';
import { UserListPage } from './user-list-page';
import { UserProfilePage } from './user-profile-page';

export function AdminRouter(): JSX.Element {
  const theme = useTheme();
  const [sidebarOpen, setSidebarOpen] = React.useState(true);

  return (
    <>
      <AdminDrawer open={sidebarOpen} onToggle={() => setSidebarOpen((o) => !o)} />
      <div
        style={{
          marginLeft: sidebarOpen ? DRAWER_WIDTH : 0,
          transition: theme.transitions.create('margin-left', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.standard,
          }),
          height: '100%',
        }}
      >
        <Routes>
          <Route path={'/*'} element={<Navigate to={'users'} />} />
          <Route path={'/users/:username'} element={<UserProfilePage />} />
          <Route path={'users'} element={<UserListPage />} />
          <Route path={'roles'} element={<RoleListPage />} />
          <Route element={<Navigate to={'users'} />} />
        </Routes>
        <Outlet />
      </div>
    </>
  );
}
